import { togglePageLoader } from "store/actions"
import { call, put, takeEvery } from "redux-saga/effects"
import toast from "toastr"

// Login Redux States

import {
  deleteProfile,
  get_category_list,
  get_profile_list,
  upateProfile,
  updatereport,
} from "helpers/backend_helper"
import {
  ADD_NEW_PROFILE,
  DELETE_PROFILE,
  PROFILE_DATA,
  TRACK_CATEGORY_VALUE,
  UPDATE_PROFILE,
  UPDATE_WORK_REPORT,
} from "./actiontype"
import {
  addprofileFail,
  addprofileSuccess,
  deleteprofileFail,
  deleteprofileSuccess,
  getAllCategoryError,
  getAllCategorySuccess,
  profileDataError,
  profileDataSuccess,
  updateprofileFail,
  updateprofileSuccess,
  workReportFail,
  workReportSuccess,
} from "./action"
import { POST_DELETE_PROFILE } from "helpers/url_helper"

function* getcategoryValues() {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_category_list)
    if (response.status === "Success") {
      yield put(getAllCategorySuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(getAllCategoryError(response))
      toast.error(response)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getAllCategoryError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}
function* getprofileData({ payload: params }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_profile_list, params)
    if (response.status === "Success") {
      yield put(profileDataSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(profileDataErr(response))
      toast.error(response)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(profileDataError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

// Add profile API Call
function* addnewprofile({ payload: profile, callback }) {
  try {
    const response = yield call(upateProfile, profile)
    yield put(togglePageLoader(true))

    if (response.statusCode === 200) {
      yield put(addprofileSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      callback("SUCCESS")
    } else {
      yield put(addprofileFail(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback("FAILURE")
    }
  } catch (error) {
    yield put(addprofileFail(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
    callback("FAILURE")
  }
}
// update profile API Call
function* updateProfile({ payload: profile, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(upateProfile, profile)
    if (response.statusCode === 200) {
      yield put(updateprofileSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      callback("SUCCESS")
    } else {
      yield put(updateprofileFail(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback("FAILURE")
    }
  } catch (error) {
    yield put(updateprofileFail(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
    callback("FAILURE")
  }
}
function* updateworkreport({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(updatereport, data)
    if (response.statusCode === 200 && response?.status === "Success") {
      yield put(workReportSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      callback("SUCCESS")
    } else {
      yield put(workReportFail(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback("FAILURE")
    }
  } catch (error) {
    yield put(workReportFail(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
    callback("FAILURE")
  }
}

function* deleteprofile({ payload: id }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(deleteProfile, id)
    if (response.statusCode === 200) {
      yield put(deleteprofileSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      yield put(deleteprofileFail(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(deleteprofileFail(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

function* trackprofilesage() {
  yield takeEvery(TRACK_CATEGORY_VALUE, getcategoryValues)
  yield takeEvery(PROFILE_DATA, getprofileData)
  yield takeEvery(ADD_NEW_PROFILE, addnewprofile)
  yield takeEvery(UPDATE_PROFILE, updateProfile)
  yield takeEvery(UPDATE_WORK_REPORT, updateworkreport)
  yield takeEvery(DELETE_PROFILE, deleteprofile)
}

export default trackprofilesage
